<template>
    <DxPopup v-model:visible="popup.visible"
             :title="popup.title"
             width="auto"
             height="auto"
             content-template="changeStatus">
        <template #changeStatus>
            <div class="puChangeStateMessage">
                Are you ready to send your application?
                If yes, click on the button "OK" below.
            </div>
            <div class="puChangeStateButtons">
                <div class="puChangeStateButton">
                    <DxButton text="Cancel"
                              @click="popupChangeStateCancel"
                              type="default"></DxButton>
                </div>
                <div class="puChangeStateButton">
                    <DxButton text="OK"
                              @click="changeStateOnServer"
                              type="success"></DxButton>
                </div>
            </div>
        </template>
    </DxPopup>

    <div class="page-content">
        <div class="content">
            <h1 class="pqHeadFirst"> Welcome to the AI Grid Platform</h1>
            <h2 class="pqHeadSec">Thank you for your interest and your application for AI Grid. <br /> You can follow here the application progress:</h2>
            <div class="icon-app">
                <div class="icon">
                    <img :class="{icon:true , iconSent: StgId>= 10 || submitted==true}" v-bind:src="iconSent" />
                    <span :class="{iconSent: StgId>= 10 || submitted==true }">Application sent  </span>
                </div>
                <div class="line">

                    <div class="divider"></div>
                </div>
                <div class="icon">
                    <img :class="{icon:true , iconRew: StgId>=12}" v-bind:src="iconRew" />
                    <span :class="{iconRew: StgId>=12 }">Application is reviewed</span>
                </div>
                <div class="line">
                    <div class="divider"></div>
                </div>
                <div class="icon">
                    <img :class="{icon:true , iconFeed: StgId>12}" v-bind:src="iconFeed" />
                    <img :class="{iconfeedResult:true , iconAccepted: StgId == 15}" v-bind:src="iconAccepted" />
                    <img :class="{iconfeedResult:true , iconDeclined: StgId == 20}" v-bind:src="iconDeclined" />
                    <span :class="{iconFeed: StgId>12}">Final Feedback</span>
                    <span :class="{accepted:true , iconAccepted: StgId == 15}">Accepted</span>
                    <span :class="{declined:true , iconDeclined:  StgId == 20}">Declined</span>
                </div>
            </div>
            <div class="lgi-btns">
                <DxButton type="success"
                          v-if=" StgId < 10 && submitted==false "
                          text="Submit your Application"
                          icon="fa-light fa-paper-plane"
                          :disabled="fullfill!=100"
                          @click="SendApp()"
                          width="235px">

                </DxButton>
                <DxButton v-if="writeAccess"
                          type="default"
                          icon="fa-light fa-money-check-pen"
                          text="Edit your application"
                          @click="EditApp()"
                          width="235px">
                </DxButton>
                <DxButton type="default"
                          v-if="!writeAccess"
                          icon="fa-regular fa-eye"
                          @click="ViewApp()"
                          width="235px"
                          text="View your application">

                </DxButton>
            </div>
            <div class="missing-fields">
                <div>
                    completeness of your application
                </div>
                <span>
                    To complete and submit your application you have to fill out all fields of the application form.
                </span>
                <div class="progress">
                    <span>Your application is</span>
                    <div class="progress-bar">
                        <div id="filledBarGrey" class="filled-bar-grey">

                        </div>
                        <div class="fullfill">

                            <div id="filledBar" class="filled-bar">

                            </div>
                            <div class="fullfill-percent">
                                {{fullfill}}%
                            </div>
                        </div>

                    </div>
                    <span>complete.</span>
                </div>
                <div v-if="missed" class="fields">
                    Missing parts of your application
                    <ul>
                        <li v-for="(field, index) in missingFields" :key="index">- {{field}}<br /></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="img-bg">
            <div class="bg-image-sq">
                <img class="bg-image" v-bind:src="bgSq" />
            </div>

        </div>
    </div>

</template>
<script>
    import { DxButton } from 'devextreme-vue/button';
    import axios from "axios";
    import { DxPopup } from 'devextreme-vue/popup';
    import $ from 'jquery';
    const baseUri = "WebApi.asmx/api/application";
    export default {

        name: 'LandingPage',
        components: {
            DxButton,
            DxPopup
        },
        data() {
            return {
                popup: {
                    visible: false,
                    title: "Confirm Submission"
                },
                writeAccess: false,
                submitted: false,
                post: null,
                fullfill: 0,
                missingFields: [],
                missed: 0,
                TopicId: 0,
                StatusId: 0,
                StgId: 0,
                //iconRew: "~/Images/221219_AI-Grid_Icon_Application.svg",
                //iconFeed: "~/Images/221219_AI-Grid_Icon_Invitation.svg",
                iconSent: "~/Images/230112_AI-Grid_Icon_Sent.svg",
                bgSq: "",
                iconAccepted: "~/Images/230112_AI-Grid_Icon_Accepted.svg",
                iconDeclined: "~/Images/230112_AI-Grid_Icon_Declined.svg",
                logoBmbf: "~/Images/Logo_BMBF_en.svg",
            }
        },
        computed: {
            iconRew() {
                return "~/Images/230112_AI-Grid_Icon_Review.svg"
            },
            iconFeed() {
                return "~/Images/230112_AI-Grid_Icon_Feedback.svg"
            },
        },
        created: function () {
            axios.get(baseUri + '/GetApplicationStatus')
                .then(res => {
                    this.post = res.data;
                    if (this.post.canCreateNew && this.post.hasTopic == false) {
                        window.location.href = "IdeaApplicationCreateDx.aspx";
                        return
                    }
                    this.$store.dispatch("getTopicAccess", { args: this.args, topicId: this.post.topic.TopicId }).then(res2 => { 
                        this.writeAccess = res2.access.Update;
                        this.TopicId = this.post.topic.TopicId;
                        this.StatusId = this.post.topic.StatusId;
                        this.fullfill = this.post.topic.TpcFullfillment;
                        this.submitted = this.post.topic.IsSubmitted;
                        this.StgId = this.post.topic.StgId;
                        this.missingFields = this.post.missingFields;
                        this.missed = this.missingFields.length;
                        var bar = document.getElementById("filledBar");
                        var barGrey = document.getElementById("filledBarGrey");
                        this.fullfill = this.fullfill ? this.fullfill : 0;
                        if (bar && barGrey) {
                            bar.style.width = this.fullfill + '%';
                            barGrey.style.width = 100 - this.fullfill + '%';
                            if (this.fullfill == 100) {
                                bar.style.borderRadius = "10px";
                            }
                            if (this.fullfill == 0)
                                barGrey.style.borderRadius = "10px";
                        }


                    }
                    )
                })



        },

        methods: {
            SendApp() {
                this.popup.visible = true;
            },
            changeStateOnServer() {
                this.$store.dispatch("SubmitApplication", { topicId: this.TopicId, statusId: 0, fullfillmentNo: 1, submitToast:"Your application was successfully submitted" }).then((res) => {
                    if (res.data.success) {
                        this.submitted = true;
                    }
                });
                this.popup.visible = false;
            },
            popupChangeStateCancel() {
                this.popup.visible = false;
            },
            EditApp() {
                $("form").attr("action", window.location.pathname + "?action=edit&topicId=" + this.TopicId).submit()
            },
            ViewApp() {
                $("form").attr("action", window.location.pathname + "?action=view&topicId=" + this.TopicId).submit()
            },
        }
    }
</script>
<style scoped>
    .fields {
        padding-top: 25px;
    }

        .fields ul {
            font-weight: normal;
            padding: 0px;
        }

    #app li {
        padding-bottom: 15px;
        margin-left: 0px;
        list-style-type: none;
    }

    img.icon {
        opacity: 0.3;
    }

    .progress span {
        color: var(--bg-color1);
        font-weight: bold;
    }

    img.iconfeedResult {
        display: none;
    }

        img.iconfeedResult.iconAccepted,
        img.iconfeedResult.iconDeclined {
            opacity: 1;
            display: unset;
        }

    img.iconSent.icon, img.iconRew.icon, img.iconRew.icon {
        opacity: 1;
    }

    img.iconFeed.icon, span.iconFeed, span.accepted, span.declined {
        display: none;
    }

        span.accepted.iconAccepted, span.declined.iconDeclined {
            display: unset;
        }

    span.iconSent, span.iconRew, span.iconAccepted, span.iconDeclined {
        color: #313741;
    }

    .divider {
        display: inline-block;
        border-bottom: #999999 1px solid;
        width: 70px;
        color: #999999;
        vertical-align: middle;
    }

    .line {
        align-items: center;
        margin-bottom: 40px;
    }

    .register {
        margin-top: 10px;
        font-size: 15px;
        font-weight: bold;
        color: white;
        text-align: center;
    }

    .icon-app {
        margin-bottom: -5px;
        max-width: 600px;
        display: grid;
        grid-template-columns: 20% 20% 20% 20% 20%;
        column-gap: 5px;
        padding: 30px 45px 20px 0px;
    }

    div.icon-app > div {
        display: grid;
        font-size: 15px;
        color: #a3a3a3;
        font-weight: bold;
        grid-row-gap: 12px;
        text-align: center;
        justify-items: center;
    }

    .lgi-btns {
        padding-top: 30px;
        display: flex;
        flex-direction: row;
        column-gap: 20px;
        row-gap: 10px;
    }

    .missing-fields {
        padding-top: 30px;
        display: grid;
        grid-row-gap: 15px;
    }

        .missing-fields span {
            color: #465a64;
        }

        .missing-fields div {
            color: #465a64;
            font-size: 15px;
            font-weight: bold;
        }

    span.grey-text {
        font-size: 15px;
        margin: 0px 20px 0px 20px;
        color: #a3a3a3;
        font-weight: bold;
    }

    img.icon {
        /*padding-right: 45px;*/
    }
     

    h4, h3 {
        color: #465a64;
        font-size: 17px;
        font-weight: lighter;
    }

    h4 {
        margin: 0px 0px 10px 0px;
        max-width: 90%;
    }

    h3.head-forth {
        color: #00a4e0;
        margin: 35px 0px 15px 0px;
        font-size: 17px;
        font-weight: bold;
    }

    h3.head-third {
        margin: 35px 0px 10px 0px;
        font-weight: bold;
    }


  
    .page-content {
        width: 100%;
        display: grid;
        grid-template-columns: auto auto;
        margin: 10px 0px 10px 0px;
    }

    .progress {
        display: flex;
        column-gap: 10px;
        padding-top: 15px;
    }

    .progress-bar {
        border-width: 0px;
        border-radius: 10px;
        height: 20px;
        width: 500px;
    }

    .filled-bar {
        background-color: #ec9b4d;
        width: 0%;
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
        height: 20px;
        position: absolute;
    }

    .fullfill {
        position: relative;
    }

    div.missing-fields div.fullfill div.fullfill-percent {
        position: absolute;
        font-size: 12px;
        height: 20px;
        margin-top: 3px;
        color: #465a64;
        margin-left: 50%;
        font-weight: normal;
    }

    .filled-bar-grey {
        background-color: #ebebeb;
        width: 100%;
        float: right;
        color: white;
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
        height: 20px;
    }
    /* Extra small devices (phones, 600px and down) */
    @media only screen and (max-width: 600px) {
        span.dx-button-text {
            display: unset;
        }

        .line {
            margin-bottom: unset;
        }

        .progress-bar {
            width: 100%;
        }

        .progress {
            display: flex;
            flex-direction: column;
            justify-self: center;
            width: 100%;
        }

        .missing-fields, .missing-fields div {
            text-align: center;
        }

        .page-content {
            margin: 10px 0px 10px 0px;
        }

        /*.content {
            text-align: center;
        }
*/
        .img-bg {
            display: none;
        }

        .img-icon {
            padding: 0;
        }

        .icon-app {
            display: flex;
            flex-direction: column;
            justify-items: center;
            padding: 0;
            gap: 20px;
        }

        h3.head-forth {
            text-align: center;
        }

        div.icon-app > div {
            justify-items: center;
            text-align: center;
        }

        .lgi-btns {
            padding-top: 30px;
            padding-right: 0;
            padding-left: 0;
            flex-direction: column;
        }

            .lgi-btns .dx-button {
                width: auto !important;
            }

        span.grey-text {
            text-align: center;
            padding-top: 10px;
            padding-bottom: 10px;
        }
    }
</style>